import React from "react";

interface AnswerOptionsProps {
  optionCount: number;
  selectedOption: number | null;
  isSavingAnswer: boolean;
  isQuizActive: boolean;
  onOptionSelect: (optionIndex: number) => void;
}

const AnswerOptions: React.FC<AnswerOptionsProps> = ({
  optionCount,
  selectedOption,
  isSavingAnswer,
  isQuizActive,
  onOptionSelect,
}) => (
  <div className="flex-grow-1 d-flex justify-content-center align-items-center">
    <div className="text-center">
      <h5 className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '1rem' : '1.25rem' }}>Select your answer:</h5>
      <div className="d-flex flex-wrap justify-content-center gap-2 gap-md-3">
        {Array.from({ length: optionCount }, (_, index) => (
          <button
            key={index}
            className={`btn ${
              selectedOption === index 
                ? 'btn-primary' 
                : 'btn-outline-primary'
            }`}
            style={{ 
              borderRadius: '50%',
              width: window.innerWidth < 768 ? '60px' : '80px',
              height: window.innerWidth < 768 ? '60px' : '80px',
              fontSize: window.innerWidth < 768 ? '18px' : '24px',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              boxShadow: selectedOption === index 
                ? '0 6px 20px rgba(0,123,255,0.4)' 
                : '0 3px 10px rgba(0,0,0,0.1)',
              transform: selectedOption === index 
                ? 'scale(1.1)' 
                : 'scale(1)',
              opacity: isSavingAnswer ? 0.6 : 1
            }}
            onClick={() => onOptionSelect(index)}
            disabled={!isQuizActive || isSavingAnswer}
            onMouseEnter={(e) => {
              if (selectedOption !== index && !isSavingAnswer) {
                e.currentTarget.style.transform = 'scale(1.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedOption !== index && !isSavingAnswer) {
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
          >
            {isSavingAnswer && selectedOption === index ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Saving...</span>
              </div>
            ) : (
              String.fromCharCode(65 + index)
            )}
          </button>
        ))}
      </div>
      {selectedOption !== null && (
        <div className="mt-2">
          {isSavingAnswer ? (
            <div className="text-warning" style={{ fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem' }}>
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Saving...</span>
              </div>
              Saving answer: <strong>{String.fromCharCode(65 + selectedOption)}</strong>
            </div>
          ) : (
            <div className="text-success" style={{ fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem' }}>
              <i className="fas fa-check-circle me-2"></i>
              Answer selected: <strong>{String.fromCharCode(65 + selectedOption)}</strong>
            </div>
          )}
        </div>
      )}
    </div>
  </div>
);

export default AnswerOptions;
